import React from 'react'
import useMedia from 'use-media'
import { css } from '@emotion/react'

import ProductMobileLogo from '@/assets/icons/product-logo-small.inline.svg'
import ProductLogo from '@/assets/icons/product-logo.inline.svg'

import mediaQueries from '@/layout/media-queries'

const productLogoWrapperCss = css`
  display: flex;
  align-items: center;
  margin-right: 16px;

  > svg {
    width: 20px;
    height: 20px;
  }

  ${mediaQueries.smallScreen()} {
    > svg {
      width: 110px;
      height: 30px;
    }
  }
`

const Logo = () => {
  const isTablet = useMedia({
    minWidth: mediaQueries.BASE_SMALL_SIZE,
  })

  return (
    <a
      alt={process.env.GATSBY_PRODUCT_LABEL}
      rel="noopener noreferrer"
      href={process.env.GATSBY_PRODUCT_WEBSITE_URL}
      css={productLogoWrapperCss}
    >
      {isTablet ? <ProductLogo /> : <ProductMobileLogo />}
    </a>
  )
}

export default Logo
